import React, { useState } from 'react';
import { Collapse, Col } from 'reactstrap';
import parse from 'html-react-parser';
import { QuestionTitle, QuestionText } from './styles';

export const Question = ({ data: { question, answer } }) => {
  const [opened, setOpened] = useState(false);
  const toggleOpen = () => setOpened(!opened);

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      toggleOpen(event);
    }
  };
  const handleFocus = event => {
    if (opened === false) {
      toggleOpen(event);
    }
  };
  const handleMouseDown = event => {
    event.preventDefault();
    toggleOpen(event);
  };

  return (
    <Col xs="12" className="py-1 px-0 mx-0" tabIndex="0" onKeyPress={handleKeyPress}>
      <QuestionTitle
        onFocus={handleFocus}
        onMouseDown={handleMouseDown}
        className={`${opened ? 'active' : ''} pl-4 ml-n1`}
      >
        <div className="dds__icons ml-1 ml-sm-0">⏵</div>
        <u>{question}</u>
      </QuestionTitle>
      <Collapse isOpen={opened} className="pt-1">
        <QuestionText>
           { parse(answer) }
        </QuestionText>
      </Collapse>
    </Col>
  );
};
